<template>
  <div class="dropdown-block">
    <div class="heading">
      {{ label }}
      <img v-if="toolTip" :src="getImage('question-icon.svg')" alt="" @click="openTooltipPopup">
    </div>
    <div class="valves-btn-container">
      <draggable v-model="ownValves" v-bind="dragOptions" @start="drag=true" @end="drag=false">
          <valves-extra-item
              v-for="(valve, index) in ownValves"
              :valve="valve"
              :buildIndex="index"
              :key="'valve' + index"
              :draggable="true"
              @edit="openPopup(index)">
          </valves-extra-item>
      </draggable>
      <coddin-button v-if="maxValves" :pName="$t('powerpack.menu.addValve')" @codd_input="addValve"/>
    </div>
  </div>
</template>

<script>
import ValvesExtraItem from './ValvesExtraItem'
import CoddinButton from "../../input/Button";
import {mapGetters, mapState} from "vuex";
import tooltipMixin from "../../../mixins/tooltipMixin";
import draggable from 'vuedraggable'

  export default {
    name: "ValvesExtra",

  props: {
    label: {
      default: 'Placeholder label'
    },
  },
  data() {
    return {
      sortedValves: [],
      drag: false,
    }
  },
  mixins: [tooltipMixin],
  components: {
    CoddinButton,
    ValvesExtraItem,
    draggable
  },
  computed: {
    ...mapState({
      allValves: state => state.valves.all,
    }),
    ...mapGetters({
      motorOption: 'build/getMotorOption',
      valves: 'build/valves/getValves'
    }),
    maxValves() {
      if (this.motorOption === 'workplace') {
        return Object.keys(this.valves).length < 1;
      }
      if (this.motorOption === 'open_frame') {
        return Object.keys(this.valves).length < 1;
      }

      return Object.keys(this.valves).length < 9
    },
    ownValves: {
      get() {
        // For images to correspond with valve list order, flip the array
        return this.valves.map((v) => this.allValves[v.id]).slice().reverse();
      },
      set(valves) {
        // Flip the array back when setting the new order
        const updatedValveList = valves.map((v) => {
          return this.valves.find(x => x.id === v.id);
        }).slice().reverse();

        this.$store.commit('build/valves/updateAllValves', updatedValveList);
      }
    },
    valvesLeft() {
      return Object.keys(this.allValves).length - this.ownValves.length;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    addValve() {
      if (this.motorOption === 'workplace') {
        this.$store.dispatch('build/valves/addValveToTheEnd');
        this.openPopupNewValve(0);
      } else {
        this.$store.dispatch('build/valves/addValve');
        this.openPopupNewValve(this.ownValves.length - 1);
      }
    },
    openPopupNewValve(index) {
      this.$emit('onValveCreate', index)
    },
    openPopup(index) {
      const flippedIndex = this.ownValves.length - index - 1;
      this.$emit('onValveClick', flippedIndex)
    },
    openTooltipPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    }
  },
}
</script>

<style scoped lang="scss">
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  border-radius: 50px;
}

.valves-btn-container {
  max-height: 100%;
  display: flex;
  align-content: flex-start;
  flex-direction: column;

  .button-container {
    width: 100%;
  }
}
</style>
